import { cn } from "@lib/cn";
import { isBlurhashValid } from "blurhash";
import { Blurhash as BlurhashComponent } from "react-blurhash";

const Blurhash = ({
  blurhash,
  style,
  className,
}: {
  blurhash: string;
  style?: React.CSSProperties;
  className?: string;
}) => {
  if (!isBlurhashValid(blurhash)) return null;
  return (
    <BlurhashComponent
      hash={blurhash}
      className={cn("!tw-absolute tw-inset-0 !tw-size-full", className)}
      style={style}
    />
  );
};

export default Blurhash;
